module.exports = __webpack_public_path__ + "static/pink-f03e2acf63bda17c39984c4c00e86bd9.svg";